import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/RegistrationDeliveryHistorical/${dossierId}/economicPlan`, method: 'GET', token: token })
}
